import { render, staticRenderFns } from "./deleteClasses.vue?vue&type=template&id=12f5d3b0&scoped=true"
import script from "./deleteClasses.vue?vue&type=script&lang=js"
export * from "./deleteClasses.vue?vue&type=script&lang=js"
import style0 from "./deleteClasses.vue?vue&type=style&index=0&id=12f5d3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f5d3b0",
  null
  
)

export default component.exports